"use strict";

module.exports = {
    "lang-switcher": {
        "all": "Ещё"
    }
};